export default __webpack_public_path__ + "static/image-7-69afe74fc444deb619fd312a3a2ebd9d.png";